// CardWrap.js
import {
  defineComponent,
  computed,
  inject,
  ref,
} from "/Scripts/vue.esm-browser.js";
import ProductCard from "/Component/Promotions/Keyword/product/ProductCard.js";
const html = String.raw;
export default defineComponent({
  name: "CardWrap",
  components: {
    ProductCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    groupShowType: {
      type: String,
    },
    isAllProduct: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    isFilterOpen: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    subAreaName: {
      type: String,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const items = computed(() => props.items);
    const showAllClicked = ref(false);
    let groupShowType = inject("groupShowType");

    //如果有傳進來就用傳進來的 例如其他出發日期一定是uni模式
    if (props.groupShowType) {
      groupShowType = props.groupShowType;
    }
    const loopItems = computed(() => {
      return items.value.filter((item) => item.groups.length > 0);
    });
    const handleShowAllClick = () => {
      showAllClicked.value = true;
    };

    return {
      items,
      loopItems,
      groupShowType,
      mobileFilterPopup,
      showAllClicked,
      handleShowAllClick,
    };
  },
  template: html`
    <div class="card_wrap">
      <div class="card_wrap-title" v-if="subAreaName">
        <div class="">
          <div class="arrow">
            <img
              loading="lazy"
              src="/action/theme/clearanceSale/V2/images/card_wrap-title-arrow.png"
              alt=""
            />
          </div>
          <div>{{ subAreaName }}</div>
        </div>
      </div>
      <product-card
        v-for="item in loopItems"
        :key="item.groups[0]?.groupCode||item.mainGroupCode"
        :item="item"
        :is-all-product="isAllProduct"
        :is-search="isSearch"
        :groupShowType="groupShowType"
        :is-loading="isLoading"
      ></product-card>
    </div>
  `,
  methods: {},
});
